<template lang="html">

  <section class="banner-localizaciones row-center ais">
    <article class="textos column-start">

      <div class="container -half ">

        <h2 class="title -black -xs">{{$t('banner_localizaciones.titulo')}}</h2>

          <p class="-direccion">{{$t('banner_newsletter.cuerpo')}}</p>
          <p class="-email">{{$t('banner_newsletter.email')}} <a href="mailto:info@aldonzagourmet.com">info@aldonzagourmet.com</a></p>
          <p class="-telefono"><span>{{$t('banner_newsletter.telefono')}}</span>  <span><a href="tel:+0034967217711">(+34) 967 21 77 11</a></span> <span class="line">-</span> <span><a href="tel:+0034660634959">(+34) 660 634 959</a></span></p>

        <!-- <p class="-direccion" v-html="$t('banner_localizaciones.munera')"></p>

        <p class="-direccion" v-html="$t('banner_localizaciones.lezuza')"></p> -->


      </div>
    </article>
    <article class="mapa">
      <mapa></mapa>
    </article>
  </section>

</template>

<script lang="js">

  import mapa from '@/components/parts/mapa';

  export default  {
    name: 'banner-localizaciones',
    components :{
      'mapa' : mapa
    },
  }
</script>

<style scoped lang="scss">
.banner-localizaciones {
  overflow: hidden;
  background: white;
  widows: 100%;

  .title{
    padding-bottom: 10px;
  }

  .title::before{
    display:inline-block;
  }

  .textos{
    background: url("/static/img/background-banner-donde-estamos-hojas.jpg") center/cover no-repeat;
    color: black;
    width: 50%;
    padding: 50px 0;
    transform: translateY(100%);
    transition: 1s;
    opacity: 0;
  }

  .mapa{
    width: 50%;
    transform: translateY(100%);
    transition: 1s;
    transition-delay: .5s;
    opacity: 0;
  }
  

}

.launched{
    .textos,.mapa{
      transform: none;
      opacity: 1;
    }
  }


  @media screen and (max-width: 600px){
   .banner-localizaciones{
    .mapa{
      width: 100%;
    }
    .textos{
      width: 100%;
    }
   }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/banner-localizaciones.vue